
export class PlanTextInfoItemModel {
  /**
   * アイテム共通
   */
  // 受注コード
  public orderCode: string = <string>'';

  /**
   * アイテムコード共通
   */
  // アイテムコード
  public itemCode: string = <string>'';

  /**
   * アイテムコード仕様書１
   */
  // 商品付随文字情報種別
  public textKindID: string = <string>'';

  // 商品付随文字情報連番
  public textKindNum: string = <string>'';

  // 文字情報
  public stringValue: string = <string>'';

}
